<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>{{$t("navigations.shells")}}</h2>
    </div>
  </div>

  <div class="wrapper wrapper-content">
    <div class="ibox-body">
      <!-- <div class="ibox-title style_2">
        <h5>Default Shell</h5>
      </div> -->

      <div class="ibox-content">

        <!-- Checking for existing shells — hide everything until done -->
        <div v-if="isChecking" class="text-center py-3">
          <img src="../../assets/img/loading.gif" width="15" alt="Loading" />
          <div class="mt-1 text-muted" style="font-size:13px;">Please wait checking Shells...</div>
        </div>

        <!-- Only shown after check confirms no shells exist -->
        <div v-else>
          <button
            class="save_btn py-1 px-4 text-white"
            :disabled="isImporting"
            @click="importShell()"
          >
            <span v-if="isImporting">
              <img src="../../assets/img/loading.gif" width="13" alt="Loading" />
              Importing...
            </span>
            <span v-else> {{$t("navigations.import shell")}}</span>
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script src="./ShellGenerate.js"></script>